import apiCall from '@/store/apiCall';
import URLS from '@/store/urls';
import types from './types';

const actions = {
  async getFormSubmissions(
    {
      commit,
    },
    {
      companyId, page = 1, limit = 10, blockId = null, unreadOnly = false,
    },
  ) {
    commit(types.GET_FORM_SUBMISSIONS_START);
    try {
      let url = `${URLS.companyFormSubmissions(companyId)}?page=${page}&limit=${limit}`;
      if (blockId) {
        url += `&blockId=${blockId}`;
      }
      if (unreadOnly) {
        url += '&unreadOnly=true';
      }

      const { data: responseData } = await apiCall({
        type: 'GET',
        url,
        isToken: true,
      });

      const payload = {
        data: responseData.data || [],
        total: responseData.total || 0,
      };

      commit(types.GET_FORM_SUBMISSIONS_SUCCESS, payload);
    } catch (error) {
      commit(types.GET_FORM_SUBMISSIONS_FAILURE);
    }
  },

  async markAsRead({ commit }, { companyId, id }) {
    try {
      await apiCall({
        type: 'PUT',
        url: `${URLS.companyFormSubmissions(companyId)}/${id}/read`,
        isToken: true,
      });
      commit(types.MARK_AS_READ_SUCCESS, id);
    } catch (error) {
      console.error('Failed to mark submission as read', error);
    }
  },

  async markAllAsRead({ commit }, { companyId }) {
    try {
      await apiCall({
        type: 'PUT',
        url: `${URLS.companyFormSubmissions(companyId)}/read-all`,
        isToken: true,
      });
      commit(types.MARK_ALL_READ_SUCCESS);
    } catch (error) {
      console.error('Failed to mark all submissions as read', error);
    }
  },

  async getUnreadCount({ commit }, { companyId }) {
    try {
      const { data: responseData } = await apiCall({
        type: 'GET',
        url: `${URLS.companyFormSubmissions(companyId)}/unread-count`,
        isToken: true,
      });
      commit(types.GET_UNREAD_COUNT_SUCCESS, responseData.count || 0);
    } catch (error) {
      console.error('Failed to get unread count', error);
    }
  },
};

export default actions;
